import React from "react";
import { Container, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';


const AboutUs = () => {
    return (
        <>
            <Helmet>
                <title>About Us - Hockey Pipeline</title>
                <meta name="description" content="Learn about Hockey Pipeline - a hockey prospect statistics website providing deep insights into NHL prospects pre-draft and post-draft." />
                <link rel="canonical" href="https://hockeypipeline.com/about-us" />
            </Helmet>
            <Container className="container top-container" >
            <Grid container columnSpacing={4}>
                <Grid item xs={12} sm={12} md={12} >
                    <Typography variant="h4" component="div" className="page-title">
                        About Us
                    </Typography>
                    <div className="title-underline" />
                </Grid>
                <Grid item xs={12} sm={12} md={12} >
                    <Typography variant="body1" paragraph>
                        <b>Welcome to Hockey Pipeline!</b>
                        <br/>
                        <br/>
                        hockeypipeline.com is a hockey prospect statistics website originally launched in June 2023 by Daniel and Jared.
                        <br/>
                        This website was built to provide deeper insights into prospects pre-draft and post-draft as they try to become successful NHLers. We strive to provide in-depth information so the general fan can follow and learn more about their favourite prospects.
                        <br/>
                        Throughout the years leading up to the creation of this website, inspiration has come in many forms. Here is an incomplete list of those sources that helped inspire the creation of this website:                        <br/>
                        <br/>
                        <ul>
                            <li>MLB Pipeline - https://www.mlb.com/milb/pipeline</li>
                            <li>Grinding the Mocks - https://grindingthemocks.shinyapps.io/Dashboard/</li>
                            <li>Nate Silver’s 538 Projections</li>
                            <li>Bob McKenize’s countless draft rankings over the decades</li>
                            <li>ESPN Analytics’ Draft Predictor - https://espnanalytics.com/draft-predictor/</li>
                        </ul>

                        <br/>
                        All data is subject to change based on new data imports or methodology changes.
                        <br/>
                        This website and its content have no direct affiliation to the NHL, NHLPA, or any other team/league mentioned on this domain.
                        
                        <br/>
                        If you have any questions, concerns or requests, here’s how we can be reached:
                        <br/>
                        Twitter: <Link to={"https://twitter.com/hockeypipeline"}  target="_blank">@hockeypipeline</Link>
                        <br/>
                        Email: hockeypipeline@gmail.com

                    </Typography>
                </Grid>
            </Grid>
        </Container>
        </>
    );
};

export default AboutUs;
